import axios from 'axios'
import router from '../router'
import store from "@/store"
import {
  baseUrl
} from '@common/url-conf'
import {
  Message,
  MessageBox
} from 'element-ui'
import {
  utils
} from '@/utils/utils'
import LoadingUtils from './LoadingUtils'
import {
  lmd5
} from "@/utils/md5";
import {
  isOpenSign
} from "@domain";
// 超时时间
axios.defaults.timeout = 25000;
axios.defaults.baseURL = baseUrl;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;
// http请求拦截器
// const CancelToken = axios.CancelToken;
const pending = [];
let loading;
axios.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/json'; 
      //分销云 设置请求头
      config.headers["businessPlatformType"] = '0';
      config.headers["industryCloudCode"] = '0';
      config.headers["websiteCode"] = null;
    // 适配后端接口规范，根据数据类型处理POST请求
    if (/^(post)|(put)|(delete)$/i.test(config.method)) {
      if (typeof config.data === 'string') {
        // application/x-www-form-urlencoded请求时，需用qs模块序列化参数：qs.stringify(data);qs模块为axios必须模块，无需额外引入
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      } else {
        config.headers['Content-Type'] = 'application/json'
      }
    }
    config.headers["systemCode"] = localStorage.getItem('currentMenuCode');
    // todo 客户管理客户端暂时固定死header的用户信息
    // config.headers['user'] = 'dx12345678';
    if (config.method == 'get') {
      config.params = {
        _: Date.now(),
        ...config.params
      }
    }

    if (config.data && Object.prototype.toString.call(config.data) !== '[object FormData]') {
      config.data = utils.deepCloneAndTrim(config.data);
    }

    config.headers["pageUrl"] = encodeURIComponent(window.location.href);
    config.headers["customerType"] = "2"; // 0运营 1客户  2渠道


    // config.cancelToken = new CancelToken(function executor(c) {
    //   pending.push(c);
    // });
    // loading = Loading.service({
    //     fullscreen: true
    // });

    // if (config.headers.notRepeatService && config.headers.showLoading !== false) {
    //   LoadingUtils.showLoading(config.headers.loadingTarget);
    // }



    return config;
  },
  error => {
    // loading.close();
    // Message.error({
    //   message: i18n.t('msg.errTimeout')
    // })

    if (config.headers.showLoading !== false) {
      LoadingUtils.hideLoading();
    }
    return Promise.reject(error);
  }
);

// http响应拦截器
axios.interceptors.response.use(
  response => {
    /* if (response.config.headers.showLoading !== false) {
      LoadingUtils.hideLoading();
    } */
    switch (response.data.retCode) {
      case '0101':
        if (response.data && response.data.obj) {
          window.location.href = response.data.obj;
        } else {
          utils.setLogin();
        }
        // while (pending.length > 0) {
        //   pending.pop()('请求中断');
        // }
        break;
      case '0148':
        if (document.getElementsByClassName('el-message-box').length === 0) {
          MessageBox.alert('您的账号已停用，即将退出', '提示', {
            confirmButtonText: '确定',
            showClose: false,
            type: 'warning',
            callback: action => {
              if (response && response.data && response.data.obj) {
                utils.setLogout(response.data.obj);
              } else {
                utils.setLogout();
              }

            }
          });
        }
        break;
      case "0184":
      case "0186":
        if (!hasElmessageError() && !hasMessageBox()) {
          MessageBox.alert('您的账号已在别处登录，如非本人操作，建议尽快修改密码', '提示', {
            confirmButtonText: '确定',
            showClose: false,
            type: 'warning',
            callback: action => {
              if (response && response.data && response.data.obj) {
                utils.setLogout(response.data.obj);
              } else {
                utils.setLogout();
              }
            }
          });
        }
        break;
      case "0146":
      case "0147":
        if (document.getElementsByClassName('el-message-box').length === 0) {
          MessageBox.alert('登录信息已过期，请重新登录', '提示', {
            confirmButtonText: '确定',
            showClose: false,
            type: 'warning',
            callback: action => {
              if (response && response.data && response.data.obj) {
                utils.setLogout(response.data.obj);
              } else {
                utils.setLogout();
              }
              // 后端方式改了，优化最新跳转方式
              //  window.location.href = response.data.obj;
            }
          });
        }
        break;
      default:
        return response;
    }
  },
  error => {
    //判断当前请求是否设置了不显示Loading（不显示自然无需隐藏）
    if (error.config.headers.showLoading !== false) {
      LoadingUtils.hideLoading();
    }
    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          //返回 401 清除token信息并跳转到登录页面
          router.push({
            path: '/control/notAllow'
          })
          break;
        case 409:
          //返回 409 参数含有 sql html 等非法字符
          Message.error("输入内容不合法，请重新输入！");
      }
    }
    return Promise.reject(error);
  }
);

function hasMessageBox() {
  let res = document.getElementsByClassName("el-message-box");
  return res.length > 0;
}

function hasElmessageError() {
  let res = document.getElementsByClassName("el-message--error");
  return res.length > 0;
}

function showErrorMessage(response) {
  if (document.getElementsByClassName('el-message').length === 0) {
    if (response && response.data && response.data.retCode && response.data.retCode !== '0101' && response.data.retCode !== 'BAM020007' && response.data.retCode !== "BCONT339") {
      Message.error(response.data.info || '网络超时，请稍后重试');
      return;
    }
    if (!response) {
      Message.error('网络超时，请稍后重试');
    }
  }
}

export function get(url, params = {}, headers = {}, option = {}) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'GET',
      headers,
      params,
      ...option
    }).then(
      response => {
        if (!response.data.result) {
          showErrorMessage(response);
        }
        resolve(response.data)
      },
      err => {
        if (err.response && err.response.status != '401') {
          showErrorMessage(err.response);
        }
        reject(err)
      }
    )
  })
}

// export function post(url, data = {}, headers = {}, option = {}) {

//   if (headers.notRepeatService) { //新增或修改的post请求,首先get获取
//     LoadingUtils.showLoading();
//     return new Promise((resolve, reject) => {
//       axios({
//         url: headers.notRepeatService + '/notRepeat/getNotRepeatToken?key=' + Date.now(),
//         method: 'GET',
//       }).then(
//         response1 => {
//           if (response1.data.result) {
//             axios({
//               url: url,
//               method: 'POST',
//               headers: Object.assign(headers, {
//                 notRepeat: response1.data.obj
//               }),
//               data,
//               ...option
//             }).then(
//               response => {
//                 LoadingUtils.hideLoading();
//                 if (!response.data.result) {
//                   showErrorMessage(response);
//                 }
//                 resolve(response.data)
//               },
//               err => {
//                 LoadingUtils.hideLoading();
//                 if (err.response && err.response.status != '401') {
//                   showErrorMessage(err.response);
//                 }
//                 reject(err)
//               }
//             )
//           }
//         },
//         err => {
//           LoadingUtils.hideLoading();
//           if (err.response && err.response.status != '401') {
//             showErrorMessage(err.response);
//           }
//           reject(err)
//         }
//       )

//     })
//   } else {
//     //普通的post请求
//     return new Promise((resolve, reject) => {
//       axios({
//         url: url,
//         method: 'POST',
//         headers,
//         data,
//         ...option
//       }).then(
//         response => {
//           if (!response.data.result) {
//             showErrorMessage(response);
//           }
//           if (response.config.responseType === 'blob') {
//             //从请求头里获取文件的类型
//             const disposition=response.headers['content-disposition']
//             const reg=/filename=.*(\.[^\.]+)$/
//             let fileType=disposition.match(reg)
//             resolve({ data:response.data, fileType:fileType?fileType[1]:'' })
//           } else {
//             resolve(response.data)
//           }          
//         },
//         err => {
//           if (err.response && err.response.status != '401') {
//             showErrorMessage(err.response);
//           }
//           reject(err)
//         }
//       )
//     })
//   }
// }
export function post(url, data = {}, headers = {}, option = {}) {
  if (headers.notRepeatService) {
    LoadingUtils.showLoading();
  }
  let urlMap = store.state.main.whiteListSign;
  if (((urlMap.length > 0 && !urlMap.includes('/broker' +url)) || urlMap.length == 0) && isOpenSign) {
  //新增或修改的post请求,首先get获取
  return new Promise((resolve, reject) => {
    axios({
      url: "/utils/gettimestampseconds?key=" + Date.now(),
      method: "GET"
    }).then(
      response1 => {
        if (response1 && response1.data.result) {
          // 此行代码影响图片上传，会报错
          // let data = utils.deepCloneAndTrim(dataPost);
          let tempDatas = utils.sortAsc(data);
          let allParams = utils.getAllUrlParamsObj(url);
          if (utils.isObject(allParams) && JSON.stringify(allParams) != '{}') {
            // tempDatas = utils.sortAsc(allParams);
          } else {
            tempDatas = utils.sortAsc(data);
          }

          // console.log(
          //   "加密前 " +
          //     "Timestamp:" +
          //     response1.data.obj +
          //     "-params:" +
          //     JSON.stringify(tempDatas)
          // );

          // console.log(
          //   "加密后 ",
          //   lmd5
          //     .hex_md5(
          //       "Timestamp:" +
          //         response1.data.obj +
          //         "-params:" +
          //         JSON.stringify(tempDatas)
          //     )
          //     .toUpperCase()
          // );
          axios({
            url: url,
            method: "POST",
            headers: Object.assign(headers, {
              Timestamp: response1.data.obj,
              Sign: lmd5
                .hex_md5(
                  "Timestamp:" +
                  response1.data.obj +
                  "-params:" +
                  JSON.stringify(tempDatas)
                )
                .toUpperCase()
            }),
            data: tempDatas,
            ...option
          }).then(
            response => {
              LoadingUtils.hideLoading();
              if (!response.data.result && !(option && option.noErrorTip)) {
                showErrorMessage(response);
              }
              
              if (response.config.responseType === 'blob') {
                //从请求头里获取文件的类型
                const disposition = response.headers['content-disposition']
                const reg = /filename=.*(\.[^\.]+)$/
                let fileType = disposition.match(reg)
                resolve({ data: response.data, fileType: fileType ? fileType[1] : '' })
              } else {
                resolve(response.data)
              }
            },
            err => {
              LoadingUtils.hideLoading();
              if (err.response && err.response.status != "401") {
                showErrorMessage();
              }
              reject(err);
            }
          );
        }
      },
      err => {
        LoadingUtils.hideLoading();
        if (err.response && err.response.status != "401") {
          showErrorMessage();
        }
        reject(err);
      }
    );
  });
}else{
   //普通的post请求
   return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: "POST",
      headers,
      data,
      ...option
    }).then(
      response => {
        if(response) {
          LoadingUtils.hideLoading();
          if (!response.data.result && !(option && option.noErrorTip)) {
            showErrorMessage(response);
          }
          if (response.config.responseType === 'blob') {
            //从请求头里获取文件的类型
            const disposition = response.headers['content-disposition']
            const reg = /filename=.*(\.[^\.]+)$/
            let fileType = disposition.match(reg)
            resolve({
              data: response.data,
              fileType: fileType ? fileType[1] : ''
            })
          } else {
            resolve(response.data)
          }
        }
      },
      err => {
        LoadingUtils.hideLoading();
        if (err.response && err.response.status != "401") {
          showErrorMessage();
        }
        reject(err);
      }
    );
  });
}
  // } else {
  //   //普通的post请求
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       url: url,
  //       method: "POST",
  //       headers,
  //       data,
  //       ...option
  //     }).then(
  //       response => {
  //         if(response) {
  //           if (!response.data.result && !(option && option.noErrorTip)) {
  //             showErrorMessage(response);
  //           }
  //           resolve(response.data);
  //         }
  //       },
  //       err => {
  //         if (err.response && err.response.status != "401") {
  //           showErrorMessage();
  //         }
  //         reject(err);
  //       }
  //     );
  //   });
  // }
}
export default axios



// WEBPACK FOOTER //
// ./src/common/axios.js